import { isDocumentEntity } from '@atlaskit/linking-types';
import { fg } from '@atlaskit/platform-feature-flags';
import { extractAri, extractDateCreated, extractDateUpdated, extractLink, extractPersonCreatedBy, extractPersonUpdatedBy, extractProvider, extractTitle } from '../common';
import { extractPreview } from '../common/preview/extractPreview';
import { extractEntity, extractEntityEmbedUrl, extractEntityProvider, isEntityPresent } from '../entity';
export var extractSmartLinkTitle = function extractSmartLinkTitle(response, removeTextHighlightingFromTitle) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity;
      return (_extractEntity = extractEntity(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
  }
  return extractTitle(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};
export var extractSmartLinkUrl = function extractSmartLinkUrl(response) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity2;
      return (_extractEntity2 = extractEntity(response)) === null || _extractEntity2 === void 0 ? void 0 : _extractEntity2.url;
    }
  }
  return extractLink(response === null || response === void 0 ? void 0 : response.data);
};
export var extractSmartLinkAri = function extractSmartLinkAri(response) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity3, _extractEntity4;
      return ((_extractEntity3 = extractEntity(response)) === null || _extractEntity3 === void 0 ? void 0 : _extractEntity3.ari) || ((_extractEntity4 = extractEntity(response)) === null || _extractEntity4 === void 0 ? void 0 : _extractEntity4.thirdPartyAri);
    }
  }
  var data = response === null || response === void 0 ? void 0 : response.data;
  return extractAri(data);
};
export var extractSmartLinkEmbed = function extractSmartLinkEmbed(response, iframeUrlType) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      // TODO: Missing iframeUrlType
      var embedUrl = extractEntityEmbedUrl(response);
      return embedUrl ? {
        src: embedUrl
      } : undefined;
    }
  }
  return extractPreview(response === null || response === void 0 ? void 0 : response.data, 'web', iframeUrlType);
};
export var extractSmartLinkProvider = function extractSmartLinkProvider(response) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      return extractEntityProvider(response);
    }
  }
  return (response === null || response === void 0 ? void 0 : response.data) && extractProvider(response === null || response === void 0 ? void 0 : response.data);
};
export var extractSmartLinkCreatedOn = function extractSmartLinkCreatedOn(response) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity5;
      return (_extractEntity5 = extractEntity(response)) === null || _extractEntity5 === void 0 ? void 0 : _extractEntity5.createdAt;
    }
  }
  return (response === null || response === void 0 ? void 0 : response.data) && extractDateCreated(response.data);
};
export var extractSmartLinkModifiedOn = function extractSmartLinkModifiedOn(response) {
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity6;
      return (_extractEntity6 = extractEntity(response)) === null || _extractEntity6 === void 0 ? void 0 : _extractEntity6.lastUpdatedAt;
    }
  }
  return (response === null || response === void 0 ? void 0 : response.data) && extractDateUpdated(response.data);
};
export var extractSmartLinkCreatedBy = function extractSmartLinkCreatedBy(response) {
  if (!response || !response.data) {
    return undefined;
  }
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity7;
      return (_extractEntity7 = extractEntity(response)) === null || _extractEntity7 === void 0 || (_extractEntity7 = _extractEntity7.createdBy) === null || _extractEntity7 === void 0 ? void 0 : _extractEntity7.displayName;
    }
  }
  var persons = extractPersonCreatedBy(response.data);
  return !!(persons !== null && persons !== void 0 && persons.length) ? persons[0].name : undefined;
};
export var extractSmartLinkAuthorGroup = function extractSmartLinkAuthorGroup(response) {
  if (!response || !response.data) {
    return undefined;
  }
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var entity = extractEntity(response);
      var owners = entity === null || entity === void 0 ? void 0 : entity.owners;
      if (owners) {
        return owners.map(function (owner) {
          return {
            name: owner.displayName,
            src: owner.picture
          };
        }).filter(function (item) {
          return !!item;
        });
      }
    }
  }
  return extractPersonCreatedBy(response.data);
};
export var extractSmartLinkModifiedBy = function extractSmartLinkModifiedBy(response) {
  if (!response || !response.data) {
    return undefined;
  }
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _extractEntity8;
      return (_extractEntity8 = extractEntity(response)) === null || _extractEntity8 === void 0 || (_extractEntity8 = _extractEntity8.lastUpdatedBy) === null || _extractEntity8 === void 0 ? void 0 : _extractEntity8.displayName;
    }
  }
  var person = extractPersonUpdatedBy(response.data);
  return person ? person.name : undefined;
};
export var extractSmartLinkDownloadUrl = function extractSmartLinkDownloadUrl(response) {
  var _response$data;
  if (fg('smart_links_noun_support')) {
    if (isEntityPresent(response)) {
      var _entity$atlassianDoc;
      var entity = extractEntity(response);
      return entity && isDocumentEntity(entity) ? entity === null || entity === void 0 || (_entity$atlassianDoc = entity['atlassian:document']) === null || _entity$atlassianDoc === void 0 || (_entity$atlassianDoc = _entity$atlassianDoc.exportLinks) === null || _entity$atlassianDoc === void 0 ? void 0 : _entity$atlassianDoc[0].url : undefined;
    }
  }
  return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data['atlassian:downloadUrl'];
};